import React, { useMemo } from 'react';
import StatCard from 'components/molecules/stat-card';
import { useTranslation } from 'react-i18next';
import { useSmsCampaignsData } from 'infrastructure/hooks/sms-campaigns/use-sms-campaigns-data';
import BaseSpinWrapper from 'components/atoms/base-spin-wrapper';

import s from './styles.module.scss';

import type { ISmsCampaignsProgressFilters } from 'infrastructure/interfaces';

interface IProps {
  filters: ISmsCampaignsProgressFilters;
  campaignGuid: string;
}

const SmsCampaignsStats: React.FC<IProps> = ({ filters, campaignGuid }) => {
  const { t } = useTranslation();

  const { data, isLoading } = useSmsCampaignsData({ ...filters, campaignGuid });

  const cards = useMemo(() => {
    let recipientsResponseRate = 0;
    if (data.statistics.total && data.statistics.completed) {
      recipientsResponseRate = Number(
        (data.statistics.completed / data.statistics.total) * 100,
      );
    }

    return [
      {
        label: t('labels.totalRecipients'),
        count: data.statistics.total,
        color: '#61B753',
      },
      {
        label: t('labels.campaignsSent'),
        count: data.statistics.sent,
        color: '#165BCD',
      },
      {
        label: t('labels.campaignsPendingSending'),
        count: data.statistics.pending,
        color: '#FF7A00',
      },
      {
        label: t('labels.recipientsResponseRate'),
        count: `${recipientsResponseRate.toFixed(2)}%`,
        color: '#61B753',
      },
    ];
  }, [data]);

  return (
    <BaseSpinWrapper spinning={isLoading}>
      <div className={s.wrapper}>
        {cards.map(({ color, count, label }) => {
          return (
            <StatCard
              key={label}
              bgColor={color}
              count={count}
              label={label}
              titleClassNames={s.title}
            />
          );
        })}
      </div>
    </BaseSpinWrapper>
  );
};

export default SmsCampaignsStats;
